module.exports = __webpack_public_path__ + "static/api-ship-first-6ba1cc21de1e862427668dc2362e0a2e.svg";